import type { Theme } from '@emotion/react';

export const theme: Theme = {
  colors: {
    primary: '#20446A',
    secondary: '#FF8316',
    ternary: '#0084A0',
    foreground: '#1E3D5A',
    background: '#FFFFFF',
    backgroundAlt: '#F4F7F7', // primary1
    focus: '#3f95fd',
    negative: '#FF0000',
    positive: '#00A651',
    warning: '#FF8800',
  },
  shades: {
    primary1: '#F4F7F7',
    primary2: '#CEE1EA',
    primary3: '#6195CC',
    primary4: '#39699B',
    primary5: '#163e63',
    secondary1: '#FFF7F0',
    secondary2: '#FBE4D3',
    secondary3: '#FFCAA1',
    secondary4: '#FFAF70',
    secondary5: '#F5952F',
    ternary1: '#F0FCFE',
    ternary2: '#CEF2F8',
    ternary3: '#A3E5EE',
    ternary4: '#72DCEB',
    ternary5: '#00B3BF',
  },
  gradients: {
    primary: 'linear-gradient(to bottom right, #15324C, #2F6183)',
    secondary: 'linear-gradient(to bottom right, #CEF2F8, #F0FCFE)',
    aukakronur:
      'linear-gradient(-225deg, rgb(240, 252, 254) 0%, rgb(206, 242, 248) 38%, rgb(163, 229, 238) 71%, rgb(114, 220, 235) 100%);',
  },
  font: {
    family: 'LB Centro Sans, sans-serif',
    familySerif: 'LB Centro Serif, serif',
    familySerifCond: 'LB Centro Serif Cond, serif',
    familySlab: 'LB Centro Slab, serif',
  },
  graphs: [
    '#1E69B0',
    '#FF8316',
    '#0084A0',
    '#FFD500',
    '#00C078',
    '#890FB4',
    '#A5C3DF',
    '#FFCDA2',
    '#99CED9',
    '#FFEE99',
    '#99E6C9',
    '#D09FE1',
  ],
  gutter: 20,
  segmentPadding: 90,
  gridColumnCount: 12,
  baseline: 4,
  pageWidth: 1180,
  pageLimit: function pageLimit({ theme }: { theme: Theme }) {
    return theme.pageWidth + theme.breakpoints.lg.gutter * 2;
  },
  useGridOverlay: false,
  headerHeight: 80,
  headerHeightMobile: 60,
  containerGutter: 34,
  breakpoints: {
    sm: { width: 414, gutter: 36 }, //  mobile
    md: { width: 768, gutter: 50 }, //  tablet
    ipadPro: { width: 1024, gutter: 50 }, //  ipad pro
    lg: { width: 1080, gutter: 100 }, // desktop
  },
};
